import React from 'react';

export const WidgetWrapper = React.memo(function WidgetWrapper({ title, children }: { title: string; children: React.ReactNode }) {
    return (
        <div style={{
            background: "var(--bg-panel)",
            border: "1px solid var(--surface-glass-border)",
            borderRadius: "var(--radius-md)",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: 'hidden'
        }}>
            <div className="widget-header" style={{
                padding: "0.5rem 1rem",
                borderBottom: "1px solid var(--surface-glass-border)",
                backgroundColor: "var(--bg-card)",
                fontWeight: "600",
                fontSize: '0.875rem',
                cursor: "move",
                userSelect: 'none'
            }}>
                {title}
            </div>
            <div style={{ padding: "1rem", flexGrow: 1, minHeight: 0, overflowY: "auto" }}>
                {children}
            </div>
        </div>
    );
});

